import { makeObservable, observable, action, computed, runInAction } from "mobx"
import { axiosInstance } from "../const/axiosInstance"
import usersStore from "./Users"

const errorResult = (error) => error.response?.data || { status: false, message: error.message }

class Friends {
    incoming = []
    outgoing = []
    searchResults = []
    searching = false

    constructor() {
        makeObservable(this, {
            incoming: observable,
            outgoing: observable,
            searchResults: observable,
            searching: observable,
            incomingCount: computed,
            loadRequests: action,
            search: action,
            clearSearch: action,
            setRelation: action,
        })
    }

    get incomingCount() {
        return this.incoming.length
    }

    async loadRequests() {
        try {
            const { data } = await axiosInstance.get("/friends/requests")
            if (data.status) {
                runInAction(() => {
                    this.incoming = data.data.incoming
                    this.outgoing = data.data.outgoing
                })
            }
        } catch (error) {
            // the list just stays as it was
        }
    }

    async search(q) {
        this.searching = true
        try {
            const { data } = await axiosInstance.get("/friends/search", { params: { q } })
            runInAction(() => {
                this.searchResults = data.status ? data.data : []
            })
        } catch (error) {
            runInAction(() => { this.searchResults = [] })
        } finally {
            runInAction(() => { this.searching = false })
        }
    }

    clearSearch() {
        this.searchResults = []
    }

    setRelation(userId, relation, request_id) {
        this.searchResults = this.searchResults.map(user =>
            user._id === userId ? { ...user, relation, request_id } : user)
    }

    async refreshAll() {
        await Promise.all([this.loadRequests(), usersStore.getUsers()])
    }

    async sendRequest(userId) {
        try {
            const { data } = await axiosInstance.post("/friends/requests", { userId })
            if (data.status) {
                this.setRelation(userId, data.data.relation, data.data.request_id)
                await this.refreshAll()
            }
            return data
        } catch (error) {
            return errorResult(error)
        }
    }

    async respond(requestId, accept) {
        try {
            const { data } = await axiosInstance.post(`/friends/requests/${requestId}/${accept ? "accept" : "decline"}`)
            await this.refreshAll()
            return data
        } catch (error) {
            return errorResult(error)
        }
    }

    async cancel(requestId) {
        try {
            const { data } = await axiosInstance.delete(`/friends/requests/${requestId}`)
            await this.loadRequests()
            return data
        } catch (error) {
            return errorResult(error)
        }
    }

    async remove(userId) {
        try {
            const { data } = await axiosInstance.delete(`/friends/${userId}`)
            await usersStore.getUsers()
            return data
        } catch (error) {
            return errorResult(error)
        }
    }
}

export default new Friends()
